import {
  breakpointSizes,
  getBreakpointDown,
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import helperCss from 'ext-ui/style/helperCss'
import IconFont from 'src/assets/fonts/icon-font.ttf'
import RubikItalic from 'src/assets/fonts/Rubik-Italic.ttf'
import RubikMedium from 'src/assets/fonts/Rubik-Medium.ttf'
import RubikMediumItalic from 'src/assets/fonts/Rubik-MediumItalic.ttf'
import RubikRegular from 'src/assets/fonts/Rubik-Regular.ttf'
import { createGlobalStyle, css } from 'styled-components'

const GlobalStyles = createGlobalStyle`
  @font-face {
    font-family: 'Rubik-Italic';
    src: url('${RubikItalic}');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'Rubik-Medium';
    src: url('${RubikMedium}');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'Rubik-MediumItalic';
    src: url('${RubikMediumItalic}');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'Rubik-Regular';
    src: url('${RubikRegular}');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'icon-font';
    src: url('${IconFont}');
    font-weight: normal;
    font-style: normal;
  }

  * {
    box-sizing: border-box;
    padding: 0;
    margin: 0;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .ReactCollapse--collapse {
    transition: height ${styleConstants.transitionSpeed.slow} ease-out, opacity ${styleConstants.transitionSpeed.slow} ease-out;
  }

  body {
    ${getFontCss(16, themeConstants.colors.font_primary, styleConstants.fontFamilies.regular)}

    &.modal-open {
      overflow: hidden;

      ${getBreakpointDown(breakpointSizes.XSM)(css`
        position: fixed;
      `)}
    }
  }

  input:focus {
    outline: none;
  }

  #content {
    display: flex;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  button {
    border: none;
  }

  th {
    text-align: left;
  }

  input[type=number]::-webkit-inner-spin-button,
  input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  
  // CSS HELPER CLASSES FROM EXT-UI LIBRARY
  ${helperCss} 
`

export default GlobalStyles
